'use strict';
//stringCheck:: string -> string
function stringCheck(string){
	if (string.length) {
		return string;
	} else {
		return false;
	}
}
function removeCommas(string) {
	return string.replace(/,/g, '');
}

// numCheck:: string -> num || false
function numCheck(string){
	if (+string){
		return +string;
	} else {
		return false;
	}
}
// intCheck:: num -> int || false
function intCheck(num) {
	if (num === parseInt(num, 10)){
		return num;
	} else {
		return false;
	}
} 
// contributeCheck:: num -> int || false
function contributeCheck(num) {
	if (num < 5.1 && num > 0){
		return num;
	} else {
		return false;
	}
}

function calculate(month, contribute, renumeration){
	var value = ((month / 12) * .2 * (contribute/5)) * renumeration;
	return value;
}
// roundToInt:: num -> int
function roundToInt(number) {
	return number.toFixed(0);
}
// addCommas:: num -> string
function addCommas(intNum) {
  return (intNum + '').replace(/(\d)(?=(\d{3})+$)/g, '$1,');
}


$('.gesb-form__row').removeClass('error').find('.gesb-form__error').addClass('hidden');

$('.gss-calculator--inputs input').on('change keyup', function(e){
	$('.gesb-form__row').removeClass('error').find('.gesb-form__error').addClass('hidden');
	var valuesFilled = $('#calcMonths').val().length && $('#calcContribution').val().length && $('#calcRenumeration').val().length;
	
	if(valuesFilled){
		$('#finalNumber').text('').next('img').removeClass('hidden');
	}

window.setTimeout(function(){
	if(valuesFilled){
		var monthNum = intCheck(numCheck(stringCheck($('#calcMonths').val())));
		var contributionNum = contributeCheck(numCheck(stringCheck($('#calcContribution').val())));
		var renumerationNum = intCheck(numCheck(removeCommas(stringCheck($('#calcRenumeration').val()))));
			if(!monthNum) {
				$('.gesb-form__row').first().addClass('error').find('.gesb-form__error').removeClass('hidden');
				$('#finalNumber').text('')
				.next('img')
				.addClass('hidden');
			} 
			if (!contributionNum) {
				$('.gesb-form__row:nth-child(2)').addClass('error').find('.gesb-form__error').removeClass('hidden');
				$('#finalNumber').text('')
					.next('img')
					.addClass('hidden');
			} 
			if (!renumerationNum) {
				$('.gesb-form__row:nth-child(3)').addClass('error').find('.gesb-form__error').removeClass('hidden');
				$('#finalNumber').text('')
					.next('img')
					.addClass('hidden');
			} 
			if (monthNum && contributionNum && renumerationNum) {
				var finalValue = addCommas(roundToInt(calculate(monthNum, contributionNum, renumerationNum)));
				$('#finalNumber').text('$' + finalValue)
					.next('img')
					.addClass('hidden');
			}
		}
	}, 1000)

});